import ProjectDetails from './ProjectDetails';

import { IApplicationDetails } from 'features/ApplicationForm/types';
import ApplicantInformationDetails from './ApplicantInformationDetails';
import LeadershipInformationDetails from './LeadershipInformationDetails';
import ExperienceDetails from './ExperienceDetails';
import DevelopmentTeam from './DevelopmentTeam';
import DevelopmentSchedule from './DevelopmentSchedule';

export const LBAApplicationDetails = ({
  applicationData,
  files,
}: IApplicationDetails) => {
  return (
    <>
      <ProjectDetails
        projectDetails={applicationData.projectDetails}
        files={files}
      />
      {applicationData.developmentTeam && (
        <DevelopmentTeam developmentTeam={applicationData.developmentTeam} />
      )}
      {applicationData.developmentSchedule && (
        <DevelopmentSchedule
          developmentSchedule={applicationData.developmentSchedule}
        />
      )}
      <ApplicantInformationDetails
        applicantInformation={applicationData.applicantInformation}
      />
      <LeadershipInformationDetails
        leadershipInformation={applicationData.leadershipInformation}
        files={files}
      />
      <ExperienceDetails experience={applicationData.experience} />
    </>
  );
};
